import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-h01-notifications"
}
const _hoisted_2 = { class: "p-h01-notifications__inner" }
const _hoisted_3 = { class: "p-h01-notifications__header" }
const _hoisted_4 = { class: "p-h01-notifications__check" }
const _hoisted_5 = { class: "p-h01-notifications__list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "p-h01-notifications-item__detail" }
const _hoisted_8 = { class: "p-h01-notifications-item__date" }
const _hoisted_9 = { class: "p-h01-notifications-item__body" }
const _hoisted_10 = { "data-translate-skip": "" }
const _hoisted_11 = { class: "p-h01-notifications-item__point__sign" }
const _hoisted_12 = { class: "p-h01-notifications-item__point__num" }
const _hoisted_13 = { class: "p-h01-notifications-item__point__unit" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "p-h01-notifications__check" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconCheckbox = _resolveComponent("IconCheckbox")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_ModalNotifyThanksPointDenial = _resolveComponent("ModalNotifyThanksPointDenial")!

  return (_ctx.notification.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[3] || (_cache[3] = _createElementVNode("p", { class: "p-h01-notifications__header__title" }, "ポイント通知", -1)),
            _createElementVNode("button", {
              class: "p-h01-notifications__header__button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.readAllNotification && _ctx.readAllNotification(...args)))
            }, [
              _createElementVNode("i", _hoisted_4, [
                _createVNode(_component_IconBase, {
                  width: 16,
                  height: 16,
                  "view-box": "0 0 16 16",
                  "icon-color": "#1F2021"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconCheckbox)
                  ]),
                  _: 1
                })
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "p-h01-notifications__header__button__text" }, "すべてを既読にする", -1))
            ])
          ]),
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notification, ({ id, date, subject1, subject2, point, type }, key) => {
              return (_openBlock(), _createElementBlock("li", {
                key: id,
                class: "p-h01-notifications__list__item"
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["p-h01-notifications-item", {
              'p-h01-notifications-item--clickable': type === 30
            }]),
                  onClick: ($event: any) => (_ctx.showNotificationDetails(type, key))
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(date), 1),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(subject1), 1),
                        _createTextVNode(_toDisplayString(subject2), 1)
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["p-h01-notifications-item__point", `p-h01-notifications-item__point--${_ctx.pointSign(point)}`]),
                      "data-translate-skip": ""
                    }, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(point.sign ? "+" : "−"), 1),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.addComma(point.point)), 1),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.unit), 1)
                    ], 2)
                  ]),
                  _createElementVNode("div", {
                    class: "p-h01-notifications-item__read",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createElementVNode("button", {
                      class: "p-h01-notifications-item__read__button",
                      onClick: ($event: any) => (_ctx.closeNotification(id))
                    }, [
                      _createElementVNode("i", _hoisted_15, [
                        _createVNode(_component_IconBase, {
                          width: 16,
                          height: 16,
                          "view-box": "0 0 16 16",
                          "icon-color": "#1F2021"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_IconCheckbox)
                          ]),
                          _: 1
                        })
                      ]),
                      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "p-h01-notifications-item__read__text" }, "既読にする", -1))
                    ], 8, _hoisted_14)
                  ])
                ], 10, _hoisted_6)
              ]))
            }), 128))
          ])
        ]),
        (_ctx.modalName === 'notifyThanksPointDenial')
          ? (_openBlock(), _createBlock(_component_ModalNotifyThanksPointDenial, {
              key: 0,
              user: _ctx.notifyDenialUser,
              transaction: _ctx.notifyDenialTransaction,
              reason: _ctx.notifyDenialReason
            }, null, 8, ["user", "transaction", "reason"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}